import { blokToComponent, SharedDefaultTemplate } from '@repo/roche-xx-shared';
import * as React from 'react';
import { StoryData } from '../build/types';
import { getComponent } from '../helpers/get-component';

const DefaultTemplate: React.FC<StoryData> = ({ pageContext, pageResources, location }) => {
  const {
    story: { content: storyContent, id: storyId },
    footer,
  } = pageContext;
  const { hide_stock_price: hideStockPrice } = storyContent;

  const headerComponents = [];
  const mainComponents = blokToComponent(
    {
      getComponent,
      blok: storyContent,
      storyId: storyId,
    },
    'main',
  );

  const footerComponent = blokToComponent(
    {
      getComponent,
      blok: {
        ...footer.content,
        canShowStockPrice: hideStockPrice,
      },
    },
    'footer',
  );

  const onClickNoticeComponent =
    pageContext.onClickNotice &&
    blokToComponent({ getComponent, blok: pageContext.onClickNotice.content }, 'on-click-notice');

  const footerComponents = [footerComponent, onClickNoticeComponent].filter(Boolean);

  return (
    <SharedDefaultTemplate
      isNewsImporter={false}
      pageContext={pageContext}
      pageResources={pageResources}
      location={location}
      headerComponents={headerComponents}
      mainComponents={[mainComponents]}
      footerComponents={footerComponents}
      getComponent={getComponent}
    ></SharedDefaultTemplate>
  );
};

export default DefaultTemplate;
export { HeadTags as Head } from '@repo/roche-xx-shared';
